import { createFetching } from './fetching.js'
import { createAlerts } from './alerts.js'
import { createCountry } from './country.js'
import { createCurrency } from './currency.js'
import { writable } from 'svelte/store'
import { createExchangeRates } from './exchangeRates'

export const alerts = createAlerts()

export const country = createCountry()

export const currency = createCurrency()

export const exchangeRates = createExchangeRates()

export const DTBalanceIsGood = writable(true)

export const fetching = createFetching()

export const v2possible = writable(true)
